import { parseDate, sortDates } from "../../../../utilities";
export const optionsInputExpulsionOrder = {
  orderNum: {
    key: "orderNum",
    label: "Номер приказа",
    type: "text",
  },
  orderDate: {
    key: "orderDate",
    label: "Дата приказа",
    type: "date",
    required: true,
  },
  programId: {
    key: "programId",
    label: "Программа подготовки",
    type: "selectWithSearch",
    placeholder: "Выберите",
    isSearchable: true,
    required: true,
    options: [],
  },
};

export const columnsExpulsionOrderTable = [
  {
    Header: "ФИО",
    accessor: "fio",
    editable: false,
    viewType: "text",
  },
  {
    Header: "Идент.номер заявителя",
    accessor: "persNum",
    editable: false,
    viewType: "text",
  },
  {
    Header: "Дата рождения",
    accessor: "birthDate",
    editable: false,
    viewType: "text",
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Период обучения с",
    accessor: "startDate",
    editable: true,
    typeEdit: "date",
    viewType: "text",
    required: true,
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Период обучения по",
    accessor: "endDate",
    editable: true,
    typeEdit: "date",
    viewType: "text",
    required: true,
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "Результат",
    accessor: "statusName",
    editable: true,
    typeEdit: "select",
    viewType: "text",
    required: true,
    selectOptions: [
      {
        id: 0,
        value: "Выберите",
        selected: "selected",
        disabled: "disabled",
        hidden: "hidden",
      },
      { id: 2, value: "Окончил обучение" },
      { id: 3, value: "Не окончил обучение" },
    ],
  },
  {
    Header: "Серия, номер документа",
    accessor: "docNumCertificate",
    editable: true,
    typeEdit: "text",
    viewType: "text",
    required: true,
  },
  {
    Header: "Дата выдачи документа",
    accessor: "docDateCertificate",
    editable: true,
    typeEdit: "date",
    viewType: "text",
    required: true,
    sortType: (rowA, rowB, columnId) => {
      const dateA = parseDate(rowA.values[columnId]);
      const dateB = parseDate(rowB.values[columnId]);

      return sortDates(dateA, dateB);
    },
  },
  {
    Header: "",
    accessor: "deleteRow",
    editable: false,
    typeEdit: "text",
    viewType: "button",
    naming: "X",
    style: "delete-button",
  },
];

export const updateOptions = (key) => {
  if (key > 0) {
    optionsInputExpulsionOrder.orderNum.required = true;
    optionsInputExpulsionOrder.programId.disabled = true;
    optionsInputExpulsionOrder.orderDate.disabled = true;
    return optionsInputExpulsionOrder;
  } else {
    optionsInputExpulsionOrder.orderNum.required = false;
    optionsInputExpulsionOrder.programId.disabled = false;
    optionsInputExpulsionOrder.orderDate.disabled = false;
    return optionsInputExpulsionOrder;
  }
};

export const setProgramId = (options, programId) => {
  options.programId.value = programId;
  return options;
};
